import { createSlice } from "@reduxjs/toolkit";
import {
  readLocalStorageJSON,
  writeLocalStorageJSON,
} from "../utils/safeLocalStorage";

const initialState = {
  selectedPatient: readLocalStorageJSON("selectedPatient", null),
};

const patientSlice = createSlice({
  name: "patient",
  initialState,
  reducers: {
    setSelectedPatient: (state, action) => {
      state.selectedPatient = action.payload ?? null;
      writeLocalStorageJSON("selectedPatient", state.selectedPatient);
    },
    clearPatients: (state) => {
      state.selectedPatient = null;
      localStorage.removeItem("selectedPatient");
      localStorage.removeItem("MRNO");
      localStorage.removeItem("name");
      localStorage.removeItem("email");
    },
  },
});

export const { setSelectedPatient, clearPatients } = patientSlice.actions;

export default patientSlice.reducer;
